module.exports = __webpack_public_path__ + "media/3700_CT_2022_Conclusion.e02e4eb6.mp4";